// Authentication
import AmplifyAuth from "@/components/auth/AmplifyAuth.vue";
import GetJWT from "@/components/auth/GetJWT.vue";

// App Elements
import AppBar from "@/components/nav/AppBar.vue";
import TheSplashScreen from "@/components/TheSplashScreen.vue";
import TheLoadingOverlay from "@/components/TheLoadingOverlay.vue";

// Views
import Home from "@/views/Home.vue";
import LoginView from "@/views/LoginView.vue";
import DatasetManager from "@/views/DatasetManager.vue";
import SeasonManager from "@/views/SeasonManager.vue";
import UserManagement from "@/views/admin/UserManagement.vue";
import UserGuide from "@/components/UserGuide.vue";
import RanchTableManager from "@/views/RanchTableManager.vue";
import MyRanches from "@/views/MyRanches.vue";

// Datasets
import LayerSelector from "@/components/datasets/LayerSelector.vue";
import DatasetSelector from "@/components/data/DatasetSelector.vue";
import SingleDatasetSelector from "@/components/data/SingleDatasetSelector.vue";
import ExportDatasetTool from "@/components/data/ExportDatasetTool.vue";
import DatasetProperties from "@/components/datasets/DatasetProperties.vue";

// Tables
import DataTable from "@/components/tables/DataTable.vue";

// Mapping
import MapDrawer from "@/components/mapping/MapDrawer.vue";
import MapLayerSymbology from "@/components/mapping/MapLayerSymbology.vue";
import MapDrawerLayerLoader from "@/components/mapping/MapDrawerLayerLoader.vue";

const base = [
  // Authentication
  {
    path: "/amplify-auth",
    component: AmplifyAuth,
    name: "Amplify Auth",
  },
  {
    path: "/jwt",
    component: GetJWT,
    name: "JSON Web Token",
  },

  // App Elements
  {
    path: "/app-bar",
    component: AppBar,
    name: "App Bar",
  },
  {
    path: "/splash-screen",
    component: TheSplashScreen,
    name: "The Splash Screen",
  },

  {
    path: "/loader-overlay",
    component: TheLoadingOverlay,
    name: "The Loading Overlay",
  },

  // Views
  {
    path: "/",
    component: Home,
    name: "Home",
    meta: { requiresAuth: false, allowPublicAuth: true },
  },
  {
    path: "/user-guide",
    component: UserGuide,
    name: "User Guide",
    meta: {
      requiresAuth: false,
      allowPublicAuth: true,
      hideNavbar: false,
      hideFooter: true,
    },
  },

  {
    path: "/login",
    component: LoginView,
    name: "Login",
    meta: {
      requiresAuth: false,
      allowPublicAuth: true,
    },
  },
  {
    path: "/dataset-manager",
    component: DatasetManager,
    name: "Dataset Manager",
    meta: { requiresAuth: true },
  },
  {
    path: "/season-manager",
    component: SeasonManager,
    name: "Season Manager",
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/my-ranches",
    component: MyRanches,
    name: "My Ranches",
    meta: { requiresAuth: true },
  },
  {
    path: "/table-manager",
    component: RanchTableManager,
    name: "Ranch Table Manager",
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/user-management",
    component: UserManagement,
    name: "User Management",
    meta: { requiresAuth: true, requiresAdminAuth: true },
  },

  // Datasets
  {
    path: "/dataset-selector",
    component: DatasetSelector,
    name: "Dataset Selector",
  },
  {
    path: "/single-dataset-selector",
    component: SingleDatasetSelector,
    name: "Single Dataset Selector",
  },
  {
    path: "/dataset-properties",
    name: "Dataset Properties",
    component: DatasetProperties,
  },

  {
    path: "/layer-selector",
    component: LayerSelector,
    name: "Layer Selector",
  },

  // Tables
  {
    path: "/data-table",
    name: "Data Table",
    component: DataTable,
  },

  {
    path: "/export-dataset-tool",
    component: ExportDatasetTool,
    name: "Export Dataset Tool",
  },

  // Mapping
  { path: "/map-drawer", component: MapDrawer, name: "Map Drawer" },

  {
    path: "/map-layer-symbology",
    component: MapLayerSymbology,
    name: "Map Layer Symbology",
  },

  {
    path: "/map-drawer-layer-loader",
    component: MapDrawerLayerLoader,
    name: "Map Drawer Layer Loader",
  },
];

export default base;
